package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable

data class SettingsSection(
    val spec: SettingsPageSpec,
    val icon: @Composable (String) -> Unit,
    val content: @Composable () -> Unit,
) {
    val id: String get() = spec.id
    val label: String get() = spec.label
    val group: SettingsGroup get() = spec.group
}

val LocalSettingsNavigate = androidx.compose.runtime.staticCompositionLocalOf<(String) -> Unit> { {} }
